import React from 'react';
import { Page } from '../Page';
import { Shield, Activity, Brain } from 'lucide-react';
export function SupplementGlutathione() {
  return <Page pageNumber={37} variant="light" data-id="element-3166" data-mp="3q3j2lwpnhsi9">
      <div className="flex h-full gap-10" data-id="element-3167" data-mp="7w3cfpymqq0k">
        {/* Left: Product Image */}
        <div className="w-[40%] flex flex-col items-center justify-center" data-id="element-3168" data-mp="7tyysgaxicn3">
          <img src="https://cdn.magicpatterns.com/uploads/wF7rvyvUYQwou8efY5Y2Ti/pasted-image.png" alt="Thorne Glutathione-SR" className="w-full max-w-[280px] object-contain" data-id="element-3169" data-mp="2vxddoq1618g" />
        </div>

        {/* Right: Content */}
        <div className="w-[60%] flex flex-col" data-id="element-3170" data-mp="qlrpg42izlrn">
          <div className="mb-6 pt-4" data-id="element-3171" data-mp="qonpbxxxokiq">
            <p className="text-[10px] font-bold text-tealslate uppercase tracking-[0.2em] mb-3" data-id="element-3172" data-mp="mkzff8ltxcub">
              Supplement Spotlight
            </p>
            <h1 className="text-4xl font-serif text-[#1F1F1F] leading-tight mb-3" data-id="element-3173" data-mp="10iweqcro3xco">
              Glutathione-SR
            </h1>
            <p className="text-lg text-tealslate font-serif italic mb-4" data-id="element-3174" data-mp="1qm1vfptn3q52">
              The body's master antioxidant
            </p>
            <div className="w-16 h-0.5 bg-tealslate" data-id="element-3175" data-mp="1vlxztq691jl5" />
          </div>

          <div className="mb-8" data-id="element-3176" data-mp="20k7zoe2x58d3">
            <h2 className="text-sm font-bold text-[#1F1F1F] mb-3 uppercase tracking-wider" data-id="element-3177" data-mp="20j6l3zmp23qm">
              Why It Matters on GLP-1
            </h2>
            <p className="text-sm text-[#3B3B3B] leading-[1.8] mb-4" data-id="element-3178" data-mp="29kny394t1pb3">
              GLP-1 medications put the liver to work. It's the primary site of
              drug metabolism. Supporting liver detoxification pathways with the
              body's master antioxidant is a smart complement. Additionally,
              rapid weight loss mobilizes stored toxins from fat tissue,
              increasing the detox burden.
            </p>
          </div>

          <div className="mb-8" data-id="element-3179" data-mp="2scgu7cf67qn1">
            <h3 className="text-xs font-bold text-[#1F1F1F] mb-3" data-id="element-3180" data-mp="2s9b01iropykg">
              Key Benefits
            </h3>
            <ul className="space-y-2 text-xs text-[#7A7A70] leading-[1.7]" data-id="element-3181" data-mp="x7z887preq30">
              <li className="flex gap-2" data-id="element-3182" data-mp="x5wjrs49950e">
                <Shield className="w-4 h-4 text-tealslate shrink-0 mt-0.5" data-id="element-3183" data-mp="t6xg0au9feaj" />
                <span data-id="element-3184" data-mp="16xsjf7lzp36q">
                  Supports liver detox during rapid fat loss (phase I/II
                  detoxification pathways)
                </span>
              </li>
              <li className="flex gap-2" data-id="element-3185" data-mp="124zeaimlzsu4">
                <Activity className="w-4 h-4 text-tealslate shrink-0 mt-0.5" data-id="element-3186" data-mp="1gv6yp3w6flxg" />
                <span data-id="element-3187" data-mp="1bx5gel6krqn1">
                  Supports carbohydrate metabolism during metabolic shifts and
                  immune function
                </span>
              </li>
              <li className="flex gap-2" data-id="element-3188" data-mp="1puk6zt8ke4gl">
                <Brain className="w-4 h-4 text-tealslate shrink-0 mt-0.5" data-id="element-3189" data-mp="1kxbp7trbw2fv" />
                <span data-id="element-3190" data-mp="3ro1bio1eep74">
                  Cognitive support during caloric deficit, maintains optimal
                  glutathione levels
                </span>
              </li>
              <li className="flex gap-2" data-id="element-3191" data-mp="3mr15ue8gnogj">
                <span className="text-tealslate shrink-0" data-id="element-3192" data-mp="226mazhitrv40">•</span>
                <span data-id="element-3193" data-mp="275zab1qvuunh">
                  Sustained-release (SR) formula survives stomach acid for
                  steady bloodstream levels
                </span>
              </li>
            </ul>
          </div>

          <div className="mt-auto" data-id="element-3194" data-mp="1xfxm89yj5c8k">
            <div className="bg-[#EAEAE4] border border-[#D8D8D0] p-5 mb-4" data-id="element-3195" data-mp="1xeuu5yph13r2">
              <h3 className="text-xs font-bold text-[#1F1F1F] mb-2 uppercase tracking-wider" data-id="element-3196" data-mp="1jg4xulah783r">
                Dosage
              </h3>
              <p className="text-sm text-[#3B3B3B] mb-1" data-id="element-3197" data-mp="1oh2bqlogdfzg">
                <strong data-id="element-3198" data-mp="1ag87mf8fu16l">1-2 capsules daily</strong> on an empty stomach
              </p>
              <p className="text-xs text-[#7A7A70]" data-id="element-3199" data-mp="1eh1v57hyxdyy">
                60 capsules per bottle • NSF Certified for Sport
              </p>
            </div>

            <div className="flex items-center gap-3" data-id="element-3200" data-mp="34uis6bi0296k">
              <img src="https://cdn.magicpatterns.com/uploads/apjpXQduRziER6ah2LWfcy/url_qrcodecreator.com_15_15_43.png" alt="Fullscript QR Code" className="w-12 h-12 shrink-0" data-id="element-3201" data-mp="38vuiykcm10gc" />
              <p className="text-[10px] text-[#7A7A70] italic leading-[1.5]" data-id="element-3202" data-mp="2f6ddfg7oqwtu">
                If you're interested in a supplement plan tailored to you, check
                out the link below! Fullscript provides third-party tested, safe
                and effective supplements to help get your health where you want
                it at wholesale prices.
              </p>
            </div>
          </div>
        </div>
      </div>
    </Page>;
}